import { Link } from "@mui/material";
import { useContext } from "react";
import { FieldProps, useRecordContext } from "react-admin";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../OpenTabsContext";
import useNotify from "../unit/useNotify";

// const LoanNumLinkField = (_: FieldProps) => {
const LoanNumLinkField = ({ ...props }) => {
  const { backUrl } = props;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { openGlobalTabs } = useContext(OpenTabsContext);
  const navigate = useNavigate();
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  const handleClick = (appId: any, loannum: any) => {
    if (openGlobalTabs.length >= 6) {
      if (openGlobalTabs.includes("loan-" + appId + "-" + loannum)) {
        //save localStorage,backUrl. use appId_loannum_backUrl as key, value is backUrl
        if (backUrl) {
          localStorage.setItem(
            "backUrl-" + appId + "-" + loannum + "",
            backUrl
          );
        }
        navigate(`/loanSummary/` + appId + `?loannum=` + loannum);
      } else {
        errorNotify("Cannot open more than 6 tabs.");
        return false;
      }
    } else {
      if (backUrl) {
        localStorage.setItem("backUrl-" + appId + "-" + loannum + "", backUrl);
      }
      navigate(`/loanSummary/` + appId + `?loannum=` + loannum);
    }
  };
  return (
    <Link
      component="span"
      onClick={() => handleClick(record.iApplicationId, record.sLoanNum)}
      className="numericText"
      underline="none"
      sx={{
        cursor: "pointer",
        textDecoration: "none",
        "&.RaLink-link": {
          color: "#1976d2",
        },
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {record.sLoanNum}
    </Link>
  );
};

export default LoanNumLinkField;
